export default {
  LIVE_DELAYED: 'liveDelayed',
  LIVE: 'live',
  DISABLED: 'disabled',
};
